module.exports = __webpack_public_path__ + "static/media/file-add.8df5da09.svg";